package com.iregained.site.utils

import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint

object Res {

    private const val BASE = "/images"

    object Strings {
        const val APP_NAME = "IRegained"
        const val EMAIL = "info@iregained.rehab" // Main non-regional contact email

        object Nav {
            const val PRODUCTS = "Products"
            const val PATIENTS = "Patients"
            const val CLINICIANS = "Clinicians"
            const val RESOURCES = "Resources"
            const val COMPANY = "Company"
        }

        object TopNav {
            const val NEWS = "News"
            const val CONTACT = "Contact"
        }

        object Links {
            // Replace the ID with the exact video ID from your channel
            const val MYHAND_DEMO_VIDEO = "https://www.youtube.com/embed/MajuwMc6ARM"
            const val TESTIMONIAL_BEVERLEY = "https://www.youtube.com/embed/bKaXnyZT3t4"
            const val TESTIMONIAL_DAVID = "https://www.youtube.com/embed/EPLhV1wH1UY"
            const val TESTIMONIAL_MICHAEL = "https://www.youtube.com/embed/FsZETSO57Os"
            const val TESTIMONIAL_BYRON = "https://www.youtube.com/embed/xzJkFzDbZWU"


            const val MYHAND_SCIENCE = "https://www.youtube.com/embed/fOHwq7cNEAg"
            const val MYHAND_PRODUCT_DEMONSTRATION = "https://www.youtube.com/embed/MajuwMc6ARM"
            const val MYHAND_HOW_IT_WORKS = "https://www.youtube.com/embed/rRbeP-mCPsk"
            const val FOUNDER_STORY = "https://www.youtube.com/embed/rZFxLcH0YsM"

            //            const val HQ_TOUR = "https://www.youtube.com/embed/rRbeP-mCPsk"
            const val HQ_TOUR = "https://www.youtube.com/embed/_5Ir8xS5pww"
        }

        object Buttons {
            const val SUBMIT = "Submit"
            const val CANCEL = "Cancel"
            const val LEARN_MORE = "Learn More"
            const val REQUEST_DEMO = "Request Demo"
        }

        object Errors {
            const val GENERIC = "Something went wrong. Please try again."
            const val NOT_FOUND = "The page you are looking for doesn't exist."
        }
    }

    object Images {

        object NotFound {
            private const val PATH = "$BASE/not_found"

            const val NOT_FOUND_IMG = "$PATH/not_found.svg"
        }

        // Everything related to the Homepage goes inside this object
        object Home {
            // Base path for all home images: /images/home
            private const val PATH = "$BASE/home"

            const val HEADER_BANNER = "$PATH/header_banner.png"
            const val FEATURES = "$PATH/features.png"


            object Accreditations {
                // Resolves to: /images/home/accreditations
                private const val SUB_PATH = "$PATH/accreditations"
                const val HEALTH_CANADA = "$SUB_PATH/health_canada.png"
                const val FDA_APPROVED = "$SUB_PATH/fda_approved.png"
                const val CDSCO = "$SUB_PATH/cdsco_india.png"
                const val HSA = "$SUB_PATH/health_science_authority_singapore.svg"
            }

            object Audience {
                // Resolves to: /images/home/accreditations
                private const val SUB_PATH = "$PATH/audience"
                const val PATIENT_PATH = "$SUB_PATH/patient_path.png"
                const val CLINICIAN_PATH = "$SUB_PATH/clinician_path.png"
            }

            object Stats {
                private const val SUB_PATH = "$PATH/stats"
                const val ICON_WORLD = "$SUB_PATH/ic_world.svg"
                const val ICON_CANADA = "$SUB_PATH/ic_canada.svg"
                const val ICON_USA = "$SUB_PATH/ic_usa.svg"
                const val ICON_INDIA = "$SUB_PATH/ic_india.svg"
                const val ICON_EU = "$SUB_PATH/ic_europe.svg"
            }

            object Testimonials {
                private const val SUB_PATH = "$PATH/testimonials"
                const val THUMB_BEVERLY = "$SUB_PATH/thumb_beverly.png"
                const val THUMB_DAVID = "$SUB_PATH/thumb_david.png"
                const val THUMB_BYRON = "$SUB_PATH/thumb_byron.png"

                const val THUMB_MIKE = "$SUB_PATH/thumb_mike.png"
            }

            object TrustLogos {
                private const val SUB_PATH = "$PATH/trust"
                const val HSN = "$SUB_PATH/hsn_logo.svg"
                const val LU = "$SUB_PATH/laurentian_en.svg"
                const val MAYO_ASU = "$SUB_PATH/mayo_asu.svg"
                const val BAYCREST = "$SUB_PATH/baycrest_logo.svg"
                const val RVH_HOSPITAL = "$SUB_PATH/rvh_hospital.png"
                const val UNIVERSITY_OF_TEXAS = "$SUB_PATH/university_of_texas_dallas.png"
                const val UNIVERSITY_OF_CINCINNATI = "$SUB_PATH/university_of_cincinnati_logo.png"
                const val UT_HEALTH_SAN_ANTONIO = "$SUB_PATH/ut_health_san_antonio.svg"
                const val UH_St_JOHN_HOSPITAL = "$SUB_PATH/uh_st_john_hospital.png"
                const val CMC_VELLORE = "$SUB_PATH/cmc_vellore.png"
                const val TAIPEI_UNIVERSITY = "$SUB_PATH/taipei_medical_university.svg"
                const val BIOMED_ACC_TAIPEI_UNIVERSITY = "$SUB_PATH/biomed_accelerator_taipei.png"
                const val PROTOCARE = "$SUB_PATH/protocare.png"
            }

            object Benefits {
                // Resolves to: /images/home/benefits
                private const val SUB_PATH = "$PATH/benefits"
                const val NEUROPLASTICITY = "$SUB_PATH/ic_neuroplasticity.png"
                const val ENGAGEMENT = "$SUB_PATH/ic_engagement.png"
                const val ANALYTICS = "$SUB_PATH/ic_analytics.png"
            }

            object Product {
                // Resolves to: /images/home/product
                private const val SUB_PATH = "$PATH/product"

                const val DEVICE_IMG = "$SUB_PATH/full_device.jpg"
            }
        }

        object ProductPage {
            private const val PATH = "$BASE/product"
            const val OVERVIEW_BG = "$PATH/product_overview_bg.png"

            object ClinicalNeed {
                private const val SUB_PATH = "$PATH/clinical_need"
                const val COLLAGE_HAND = "$SUB_PATH/collage_hand.png"
                const val COLLAGE_DEVICE_TOP = "$SUB_PATH/collage_device_top.png"
                const val COLLAGE_DEVICE_SIDE = "$SUB_PATH/collage_device_side.png"
                const val COLLAGE_CLINICIAN = "$SUB_PATH/collage_clinician.png"
            }

            object TechnologyPillars {
                private const val SUB_PATH = "$PATH/architecture"
                const val DASHBOARD = "$SUB_PATH/dashboard_platform.png"
                const val HARDWARE_DEVICE = "$SUB_PATH/myhand_hardware.png"
                const val SOFTWARE_APP = "$SUB_PATH/myhand_software.jpg"
            }

            object Clearance {
                private const val SUB_PATH = "$PATH/clearance"
                const val ICON_INFO = "$SUB_PATH/ic_info.svg" // A clean, white info or shield icon
            }

            // Add this inside the Res.Images.ProductPage object in AppConstants.kt
            object Neuroscience {
                private const val SUB_PATH = "$PATH/neuroscience"
                const val ICON_NEUROPLASTICITY = "$SUB_PATH/ic_neuroplasticity.svg"
                const val ICON_PERSONALIZATION = "$SUB_PATH/ic_personalize.svg"
                const val ICON_VALIDATION = "$SUB_PATH/ic_validation.svg"

                const val CLINICIAN_PATIENT = "$SUB_PATH/device_patient.png" // The right-side image
                const val ICON_CHECK = "$SUB_PATH/ic_check_teal.svg" // For the bullet points

            }

            object Efficacy {
                private const val SUB_PATH = "$PATH/efficacy"
                const val ICON_THERAPY = "$SUB_PATH/ic_therapy.svg"
                const val ICON_EFFICACY = "$SUB_PATH/ic_efficacy.svg"
                const val ICON_NEURO = "$SUB_PATH/ic_neuro.svg"
                const val ICON_CLOUD = "$SUB_PATH/ic_cloud.svg"
            }

            object AudienceRouting {
                private const val SUB_PATH = "$PATH/audience"
                const val CLINICIAN_IMG = "$SUB_PATH/clinician_portal.png"
                const val PATIENT_IMG = "$SUB_PATH/patient_portal.png"
            }
        }

        object PatientsPage {
            private const val PATH = "$BASE/patients"
            const val OVERVIEW_BG = "$PATH/patients_video_cover.png"

            object NeuroplasticityEducation {
                private const val SUB_PATH = "${PATH}/neuroplasticity_edu"
                const val neuroplasticity_edu = "${SUB_PATH}/neuroplasticity_edu.jpg"
                const val ICON_CHECK = "${SUB_PATH}/ic_point.svg" // For the bullet points
            }

            object MyHandExperience {
                private const val SUB_PATH = "${PATH}/myhand_experience"
                const val NEUROPLASTICITY = "${SUB_PATH}/ic_neuroplasticity.png"
                const val ENGAGEMENT = "${SUB_PATH}/ic_engagement.png"
                const val ANALYTICS = "${SUB_PATH}/ic_analytics.png"
                const val DEVICE = "${SUB_PATH}/myhand_device.jpg"
            }

            object FeaturesAndBenefits {
                private const val SUB_PATH = "${PATH}/feature_benefits"
                const val FEATURE_BENEFITS = "${SUB_PATH}/feature_benefits_cover.jpg"
            }

            object Recovery {
                private const val SUB_PATH = "${PATH}/recovery"
                const val ACTIVE_GRASP = "${SUB_PATH}/active_grasp.png"
                const val FINGER_INDIVIDUATION = "${SUB_PATH}/finger_individuation.png"
                const val PINCH_STRENGTH = "${SUB_PATH}/pinch_strength.jpg"
                const val TASK_SIMULATION = "${SUB_PATH}/task_simulation.jpg"
                const val FORCE_ROM = "${SUB_PATH}/force_rom.png"
                const val BIO_FEEDBACK = "${SUB_PATH}/bio_feedback.jpg"
                const val INTRINSIC_MUSCLE = "${SUB_PATH}/intrinsic_muscle.jpg"
                const val GAMIFIED_ENGAGEMENT = "${SUB_PATH}/gamified_engagement.jpg"
            }
        }

        object CliniciansPage {
            private const val PATH = "$BASE/clinicians"
            const val OVERVIEW_BG = "$PATH/home_banner.mp4"

            object IMPACT {
                private const val SUB_PATH = "${PATH}/impact"
                const val EVIDENCE = "${SUB_PATH}/ic_impact_evidence.svg"
                const val REPETITION = "${SUB_PATH}/ic_impact_repetition.svg"
                const val DISRUPTION = "${SUB_PATH}/ic_impact_disruption.svg"
            }

            object WORKFLOW {
                private const val SUB_PATH = "${PATH}/workflow"
                const val WORKFLOW1 = "${SUB_PATH}/workflow_1.png"
                const val WORKFLOW2 = "${SUB_PATH}/workflow_2.jpg"
                const val WORKFLOW3 = "${SUB_PATH}/workflow_3.png"
            }

            object INTEGRATION {
                private const val SUB_PATH = "${PATH}/integration"
                const val PLUG_PLAY = "${SUB_PATH}/ic_plug_play.svg"
                const val CERTIFICATION = "${SUB_PATH}/ic_iso_13485.svg"
                const val SUPPORT = "${SUB_PATH}/ic_support.svg"
            }

            object TARGET {
                private const val SUB_PATH = "${PATH}/target"
                const val OWNER_ADMINS = "${SUB_PATH}/target_owner_admins.png"
                const val PT = "${SUB_PATH}/target_pt.png"
            }

            object EVIDENCE {
                private const val SUB_PATH = "${PATH}/evidence"
                const val TRIAL = "${SUB_PATH}/ic_impact_evidence.svg"
                const val STUDIES = "${SUB_PATH}/ic_case_study.svg"
                const val CARE = "${SUB_PATH}/ic_integrated_care.svg"
            }
        }

        object Partners {
            private const val PATH = "$BASE/partners"
            const val CARE_CREDIT = "$PATH/care_credit.png"
            const val BAJAJ_FINSERV = "$PATH/bajaj_finserv.png"
            const val MEDICARD = "$PATH/medicard.png"
        }

        object Distributors {
            private const val PATH = "$BASE/distributors"
            const val MAP_BG = "$PATH/world_map_bg.png" // Optional subtle background map
            const val EMPTY_STATE = "$PATH/ic_empty.svg" // Optional subtle background map
        }

        object About {
            private const val PATH = "$BASE/about"

            // Make sure this path is correct and your logo is in the right public directory!
            const val BANNER = "$PATH/company.jpg"

            object Origin {
                private const val SUB_PATH = "$PATH/origin"

                const val ORIGIN_IMG = "$SUB_PATH/founder_story.jpeg"
            }

            object Values {
                private const val SUB_PATH = "$PATH/values"

                const val HARDWARE = "$SUB_PATH/hardware.svg"
                const val SOFTWARE = "$SUB_PATH/software.svg"
                const val PATIENT = "$SUB_PATH/patient.svg"
            }

            object Leadership {
                private const val SUB_PATH = "$PATH/leadership"

                const val VINEET = "$SUB_PATH/vineet.jpg"
                const val SAMIR = "$SUB_PATH/samir.jpg"
                const val JOEL = "$SUB_PATH/joel.jpg"
                const val RANJIT = "$SUB_PATH/ranjit.jpg"
                const val LAURA = "$SUB_PATH/laura.jpg"
                const val MIKE = "$SUB_PATH/mike.jpg"
            }

            object Trust {
                private const val SUB_PATH = "$PATH/trust"

                const val ISO_13485 = "$SUB_PATH/iso_13485.png"
                const val ISO_9001 = "$SUB_PATH/iso_9001.png"
            }

            object Careers {
                private const val SUB_PATH = "$PATH/careers"

                const val INDEED = "$SUB_PATH/indeed.png"
            }
        }

        object Resources {
            private const val SUB_PATH = "$BASE/resources"

            const val BANNER = "$SUB_PATH/resources_banner.png"

            object Brochure {
                private const val PATH = "$SUB_PATH/brochure"

                const val BROCHURE_COVER = "$PATH/brochure_cover.png"
            }

            object Grid {
                private const val PATH = "$SUB_PATH/grid"

                const val ACADEMIC_TITLE = "$PATH/academic_title.svg"
                const val AUTHOR = "$PATH/authors.svg"
                const val VENUE = "$PATH/venue.svg"
            }
        }

        object News {
            private const val PATH = "$BASE/news"

            object Feature {
                private const val SUB_PATH = "$PATH/feature"

                //                const val FEATURE_COVER = "$SUB_PATH/manipal_hospitals.jpg"
                const val FEATURE_COVER = "$SUB_PATH/cdsco_licence.png"
            }

            object Kit {
                private const val SUB_PATH = "$PATH/kit"

                const val PRODUCT_SPEC = "$SUB_PATH/product_spec.svg"
                const val IR_ASSETS = "$SUB_PATH/ir_assets.svg"
                const val IR_VIDEOS = "$SUB_PATH/ir_videos.svg"
            }

            object Grid {
                private const val SUB_PATH = "$PATH/grid"

                const val INNOVATION_FACTORY = "$SUB_PATH/innovation_factory.png"
                const val ASU_INVESTU = "$SUB_PATH/asu_investu.png"
                const val BETTER_WAY_ALLIANCE = "$SUB_PATH/better_way_alliance.jpeg"
                const val CANADIAN_BUSINESS = "$SUB_PATH/canadian_business.svg"
                const val CBC_NEWS = "$SUB_PATH/cbc_news.png"
                const val CHANGE_RANGERS = "$SUB_PATH/change_rangers.png"
                const val CTV_NEWS = "$SUB_PATH/ctv_news_northern_ontario.png"
                const val DIGITIMES_ASIA = "$SUB_PATH/digitimes_asia.jpg"
                const val ISSUU = "$SUB_PATH/issuu.png"
                const val KEIRETSU_FORUM = "$SUB_PATH/keiretsu_forum.jpeg"
                const val LINKEDIN = "$SUB_PATH/linkedin.svg"
                const val MADE_IN_CA = "$SUB_PATH/made_in_ca.svg"
                const val NORCAT = "$SUB_PATH/norcat.png"
                const val NORTHERN_ONTARIO_ANGELS = "$SUB_PATH/northern_ontario_angels_investors.jpeg"
                const val NORTHERN_ONTARIO_BUSINESS = "$SUB_PATH/northern_ontario_business.svg"
                const val OCTANE = "$SUB_PATH/octane.svg"
                const val SUDBURY_COM = "$SUB_PATH/sudbury_com.jpg"
                const val TECHSTINATION = "$SUB_PATH/techstination.png"
                const val THE_SUDBURY_STAR = "$SUB_PATH/the_sudbury_star.svg"
                const val TWITTER_X = "$SUB_PATH/twitter_x.jpg"
                const val YOUTUBE = "$SUB_PATH/youtube.png"
            }

        }

        object Contact {
            private const val PATH = "$BASE/contact"

            object Route {
                private const val SUB_PATH = "$PATH/route"

                const val CLINICIAN = "$SUB_PATH/clinician.svg"
                const val PATIENT = "$SUB_PATH/patient.svg"
            }

            object Support {
                private const val SUB_PATH = "$PATH/support"

                const val HEADQUATER = "$SUB_PATH/headquater.svg"
            }
        }

        object Common {
            private const val PATH = "$BASE/common"

            // Make sure this path is correct and your logo is in the right public directory!
            const val LOGO = "$PATH/logo.svg"
            const val BACK_TO_TOP = "$PATH/ic_back_to_top.svg"
        }

        object Promo {
            private const val PATH = "$BASE/promo"

            const val DEVICE_1 = "$PATH/myhand_device1.jpg"
            const val DEVICE_2 = "$PATH/myhand_device2.png"
            const val DEVICE_3 = "$PATH/myhand_device3.png"
        }

        object Financing {
            private const val PATH = "$BASE/financing"

            const val CA_VENDOR_LENDER = "$PATH/ca_vendor_lender.png"
            const val IN_POONAWALLA_FINCORP = "$PATH/poonawalla_fincorp.png"
            const val US_AMERICORP = "$PATH/us_americorp.png"
        }
    }

    object Videos {
        private const val PATH = "/videos"

        object PatientsPage {
            const val PATIENTS_VIDEO = "$PATH/patients_cover.mp4"
        }

        object CliniciansPage {
            const val CLINICIAN_VIDEO = "$PATH/home_banner.mp4"
        }

        object ResourcesPage {
            const val RESOURCES_VIDEO = "$PATH/technology.mp4"
        }
    }

    object Icons {
        private const val PATH = "$BASE/icons"
        const val CALL = "$PATH/ic_call.svg"
        const val SEND_EMAIL = "$PATH/ic_email.svg"
        const val WEB = "$PATH/ic_web.svg"
        const val EMAIL_CONTACT = "$PATH/ic_email_contact.svg"
        const val LOCATION = "$PATH/ic_location.svg"

        const val CHECKMARK = "$PATH/ic_checkmark.svg"
        const val LIVE_DEMO = "$PATH/ic_live_demo.svg"
        const val CHART = "$PATH/ic_chart.svg"
        const val TRAINING = "$PATH/ic_training.svg"

        // footer icons
        const val FACEBOOK = "$PATH/ic_facebook.svg"
        const val INSTAGRAM = "$PATH/ic_instagram.svg"
        const val LINKEDIN = "$PATH/ic_linkedin.svg"
        const val TWITTER = "$PATH/ic_twitter.svg"
    }

    object Breakpoints {
        val SM = Breakpoint.SM  // 640px
        val MD = Breakpoint.MD  // 768px
        val LG = Breakpoint.LG  // 1024px
        val XL = Breakpoint.XL  // 1280px
        val XXL = Breakpoint.XXL  // 1440px
    }
}